// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from './api/index'
import utils from './utils'
import global_ from './global/index'
import VideoPlayer from '../static/js/vue-video-player'
import 'jquery'

require('video.js/dist/video-js.css')
import vant from 'vant'
// import { Loading } from 'element-ui';
import axios from 'axios'

Vue.use(vant)
Vue.use(api)

Vue.prototype.quitSystem = function () {
  var that = this
  // console.log('请求退出')
  that.$api.SIGNOUT({}).then(res => {
    if (res.retcode == 0) {
      window.location.href = res.url
    } else {
      that.$message.error(res.msg)
    }
  })
}

Vue.use(ElementUI)
Vue.use(VideoPlayer)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']

// 获取URL参数
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.hash.substr(window.location.hash.indexOf('?')).substr(1).match(reg)
  if (r != null) return decodeURI(r[2])
  return null
}

sso.event('logged', function (user) {
  console.log(123);
  console.log(user)
  var ticketObj = {
    sso_id: user.getId(),
    name: user.getDetail().realName,
    phone: user.getUsername()
  }
  console.log('2222234234234')
  console.log(ticketObj)
  window.localStorage.setItem('ticketObj', JSON.stringify(ticketObj))
  if (!window.localStorage.getItem('flag')) {
    window.localStorage.setItem('flag', 1);
    window.location.reload();
  }
})

sso.event('notLogged', function () {
  if (getQueryString('ticket') || (!getQueryString('ssoId') && getQueryString('phone') && window.location.href.indexOf('/lottery') !== -1)) {

  } else {
    sso._.variable.redirect = true// sso为兼容老的ticket的hack 写法，等无需兼容后，删除redirect=false的逻辑，正常开发禁止使用这种写法，否则后果自负
    sso.goAuth()
  }
})
sso.event('afterLogout', function () {
  if (getQueryString('ticket') || (!getQueryString('ssoId') && getQueryString('phone') && window.location.href.indexOf('/lottery') !== -1)) {

  } else {
    sso._.variable.redirect = true// sso为兼容老的ticket的hack 写法，等无需兼容后，删除redirect=false的逻辑，正常开发禁止使用这种写法，否则后果自负
    sso.goAuth()
  }
})


if (!getQueryString('ssoId') && getQueryString('phone') && window.location.href.indexOf('/lottery') !== -1) {
  let url =
    location.host == "xue.eoffcn.com"
      ? "//xue.eoffcn.com/api"
      : "//xue.t.eoffcn.com/api";
  $.ajax({
    url: url + "/cus/detail",
    type: "post",
    data: {
      phone: getQueryString('phone')
    },
    success: function (res) {
      if (res.code == 0) {
        window.localStorage.setItem('phone', res.data.username)
        window.localStorage.setItem('ssoId', res.data.id)
      }
    }
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  api,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js